<template>
  <v-dialog v-model="sigVisible" max-width="730" content-class="elevation-0" class="sigDialog">
    <v-card width="730" color="white" class="mb-0 pb-0 sigfloCard borderImage elevation-0" multi-line timeout="-1">
      <v-card-text class="sigCardText">
        <v-img class="sigfloLogo" src="@/assets/images/sigfloSymbolLogo.svg" height="142" width="142" />
        <div class="sigfloH4 textEmphasis">
          {{ sig.messageTitle }}
        </div>
        <div class="sigfloBody600 textDefault">
          {{ sig.message }}
          <!-- Sig Inputs -->
          <div class="mt-4">
            <div v-for="(input, index) in sig.inputModels" :key="index" class="">
              <v-text-field
                light
                v-if="input.controlType == 'Text'"
                outlined
                v-model="input.value"
                :label="input.name"
                :hint="input.sigMessage"
              />
              <v-text-field
                v-if="input.controlType == 'Password'"
                outlined
                type="password"
                v-model="input.value"
                :label="input.name"
                :hint="input.sigMessage"
              />
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="cardActions pb-4">
        <v-spacer />
        <v-btn
          v-for="button in sig.buttonArray"
          :key="button.label"
          rounded
          dark
          class="mr-4 elevation-0 px-4 text-capitalize sigfloButtonSmall400"
          :color="button.color"
          @click.stop.prevent="executeCallback(button.callback)"
          ><v-icon class="mr-1">{{ button.icon }}</v-icon
          >{{ button.label }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    data() {
      return {
        sigWidth: 600,
        sigHeight: 200
      };
    },
    methods: {
      executeCallback(callback) {
        if (callback) {
          callback();
        }
        this.hideSig(this.sigId);
      }
    },
    computed: {
      ...mapState('app', ['toast', 'sig']),
      sigVisible: {
        get() {
          return this.sig.show;
        },
        set(value) {
          if (value) {
            this.$store.commit('app/showSig', true);
          } else {
            this.$store.commit('app/showSig', false);
          }
        }
      }
    }
  };
</script>

<style scoped>
  .sigDialog {
    z-index: 99;
  }
  .sigCardText {
    padding-left: 200px !important;
    padding-right: 140px !important;
    padding-top: 40px !important;
  }
  .cardActions {
    padding-right: 140px !important;
  }
  .borderImage {
    border: 0px solid transparent !important;
    background-image: url('~@/assets/images/dialogRightBorder.svg');
    background-position: right top; /* Align to top right */
    background-repeat: no-repeat; /* No repeating */
    background-size: auto 100%; /* Stretch to full height of parent */
  }
  .dialogRightBorder {
    position: absolute;
    right: 0;
    top: 0;
  }
  .sigfloLogo {
    position: absolute;
    left: 48px;
    top: 76px;
  }
  /*
  div.callout {
     background-color: #200c40;
    background-image: -moz-linear-gradient(top, #4630c4, #4630c4);
     position: relative;
    color: #ccc;
    padding: 20px;
    border-radius: 3px;
    box-shadow: 0px 0px 20px #999;
    min-height: 20px;
    border: 1px solid #333;
    text-shadow: 0 0 1px #000; 
  }
  .callout::before {
    content: '';
    width: 0px;
    height: 0px;
    border: 0.8em solid transparent;
    position: absolute;
  }
  .callout.right::before {
    left: -22px;
    border-right: 10px solid #200c40;
  }
  .callout.right.bottom::before {
    bottom: 0;
  }
  .callout.right.top::before {
    top: 0;
  }
  .callout.left::before {
    right: -22px;
    border-left: 10px solid #200c40;
  }
  .callout.left.bottom::before {
    bottom: 0;
  }
  .callout.left.top::before {
    top: 0;
  } */
</style>
